/**
 * קטלוג המודולים (PRD 5.19). הרשימה כאן היא רק הטיפוס והתווית לעברית;
 * מה פעיל ומה כבוי נקבע ב app_settings.modules, בלי שינוי קוד.
 */
export const MODULE_KEYS = [
  'messages',
  'schedule',
  'learning',
  'ai_schedule',
  'ai_quiz',
  'assistant',
  'games',
  'ops',
  'sales',
  'integration',
  'hr_docs',

  // תת פיצ'רים (מיגרציה 075). ההיררכיה עצמה יושבת בטבלה
  // module_features, וה *שרת* מחשב את התוצאה: me() מחזיר מפה
  // שבה תת פיצ'ר כבר כבוי אם ההורה שלו כבוי. כאן זו רק רשימת
  // המפתחות, לטובת הטיפוסים.
  'ops_checklists',
  'ops_tasks',
  'ops_display',
  'ops_documents',
  'ops_requests',
  'ops_surveys',
  'learning_courses',
  'learning_products',
  'learning_planogram',
] as const;

export type ModuleKey = (typeof MODULE_KEYS)[number];

export const MODULE_LABELS: Record<ModuleKey, string> = {
  messages: 'מסרים ואישור קריאה',
  schedule: 'סידור עבודה, אילוצים והחלפות',
  learning: 'לומדות והכר את המוצר',
  ai_schedule: 'סידור משמרות ב AI',
  ai_quiz: 'יצירת שאלות לחידון ב AI',
  assistant: 'עוזר AI לעובדים',
  games: 'נקודות, תחרויות ומצטיינים',
  ops: 'תפעול, משימות ומסמכים',
  sales: 'מכירות, יעדים ושיאים',
  integration: 'חיבור למערכת הקופות',
  hr_docs: 'מסמכי עובד רגישים',

  ops_checklists: 'צ׳קליסטים',
  ops_tasks: 'משימות',
  ops_display: 'ויטרינה',
  ops_documents: 'נהלים וחתימות',
  ops_requests: 'בקשות חופשה ומחלה',
  ops_surveys: 'סקרים ומשוב',
  learning_courses: 'לומדות וחידונים',
  learning_products: 'מוצרים והכר את המוצר',
  learning_planogram: 'פלנוגרמה',
};

/**
 * ההורה של כל מפתח, כראי לעמודה parent_key ב module_features.
 *
 * כאן רק כדי שאפשר יהיה לבדוק בזמן בנייה שאף מסך אינו נשען על
 * מפתח אב כשקיים לו בן: שער על "learning" כשהעובד כיבה דווקא
 * את "learning_courses" נראה תקין בקוד, ובפועל משאיר את המסך
 * דולק אצל כולם חוץ מהמנהל. החישוב האמיתי נעשה בשרת.
 */
export const MODULE_PARENT: Record<ModuleKey, ModuleKey | null> = {
  messages: null,
  schedule: null,
  learning: null,
  ai_schedule: null,
  ai_quiz: null,
  assistant: null,
  games: null,
  ops: null,
  sales: null,
  integration: null,
  hr_docs: null,

  ops_checklists: 'ops',
  ops_tasks: 'ops',
  ops_display: 'ops',
  ops_documents: 'ops',
  ops_requests: 'ops',
  ops_surveys: 'ops',
  learning_courses: 'learning',
  learning_products: 'learning',
  learning_planogram: 'learning',
};

/** מפתחות שיש להם בנים, ולכן אסור לשער מסך עליהם. */
export const PARENT_MODULES: ModuleKey[] = MODULE_KEYS.filter((key) =>
  MODULE_KEYS.some((other) => MODULE_PARENT[other] === key),
);

/** מודולים שפעילים לפני שההגדרות נטענו, כדי שהתפריט לא יקרוס לפריט אחד. */
export const CORE_MODULES: ModuleKey[] = ['messages', 'schedule', 'learning'];
